import React from 'react';
import {observer} from "mobx-react";
import Live from "components/live/Live.jsx";
import useFetchDefaultLive from "hooks/useFetchDefaultLive";
import useMyStores from "hooks/useMyStores";
import liveStatusEnum from "enum/LiveStatusEnum";
import TabBar, {TabBarValue} from "../../components/tab-bar/TabBar";

const AiLive = ()=>{

    const {user: userStore, constant: constantStore} = useMyStores();
    const {data: liveInfo} = useFetchDefaultLive()


    return (
        <div>
            {
                liveInfo?.live.status === liveStatusEnum.OPEN &&
                <Live liveInfo={liveInfo} userStore={userStore}/>
            }


            <TabBar tabBarValue={TabBarValue.AiLive}/>
        </div>
    )
}

export default observer(AiLive)